module.exports = __webpack_public_path__ + "static/media/planet_responsable_medium.6b3848ff.svg";